import { h } from "preact";
import { RoutableProps } from "preact-router";
import { OrderCreator } from "../../../components/OrderCreator";
import { stellaBIO } from "../../../data/serialNumberSearchExecs";
import "./styles.scss";

export function StellaBIOOrder(props: RoutableProps & { id?: string }) {
    return <div class="stella-bio-order-page">
        <OrderCreator id={props.id} orderTypes={stellaBIO.orderTypes} serialRegexes={stellaBIO.orderedExecs}/>
    </div>;
}
